import React, { useEffect, useState } from 'react';
import { useChatStore } from '../../hooks/useChatStore';

export default function ScheduledMessagesPanel({ onClose }) {
  const { scheduledMessages, fetchScheduledMessages, cancelScheduledMessage, chats } = useChatStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      await fetchScheduledMessages();
      setLoading(false);
    };
    load();
    const timer = setInterval(fetchScheduledMessages, 20000);
    return () => clearInterval(timer);
  }, [fetchScheduledMessages]);

  const chatNameFor = (chatId) => {
    const chat = chats.find((c) => c.id === chatId);
    if (!chat) return 'Чат';
    return chat.name || chat.participants?.find((p) => p.userId !== JSON.parse(localStorage.getItem('trandi-auth') || '{}')?.state?.user?.id)?.displayName || 'Чат';
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal scheduled-panel" onClick={(e) => e.stopPropagation()}>
        <div className="scheduled-panel-header">
          <h3>⏰ Запланированные сообщения</h3>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="scheduled-panel-body">
          {loading && <div className="sticker-picker-loading">Загрузка...</div>}
          {!loading && scheduledMessages.length === 0 && (
            <div className="user-info-status muted">
              Нет запланированных сообщений. Установите дату и время ⏰ в чате, чтобы отложить отправку.
            </div>
          )}
          {scheduledMessages.map((msg) => (
            <div key={msg.id} className="scheduled-item">
              <div className="scheduled-item-info">
                <div className="scheduled-item-text">{msg.content?.substring(0, 60) || 'Сообщение'}</div>
                <div className="scheduled-item-meta">
                  ⏰ {String(msg.scheduledAt).slice(0, 16).replace('T', ' ')} · {chatNameFor(msg.chatId)}
                </div>
              </div>
              <button className="scheduled-item-delete" title="Отменить"
                onClick={() => cancelScheduledMessage(msg.id)}>🗑</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}